import { useHeroScene } from '../../hooks/useHeroScene'

/** Four-scene autoplay loop inside a phone frame, used in the landing-v2 hero.
 *  Crossfades at ~5.5s (Arrive → Intend → Reveal → Thread) via useHeroScene,
 *  which also locks at scene 0 under prefers-reduced-motion: reduce. */
const SCENES = [
  { id: 'arrive', label: 'Arrive', body: 'Open the app. Take a breath.' },
  { id: 'intend', label: 'Intend', body: 'Set the question — or just sit with it.' },
  { id: 'reveal', label: 'Reveal', body: 'Pull a card. Read what arrives.' },
  { id: 'thread', label: 'Thread', body: 'Keep what matters. Return tomorrow.' },
] as const

export function HeroPhoneLoop() {
  const { scene } = useHeroScene(SCENES.length)
  return (
    <div className="relative mx-auto w-[280px] md:w-[320px]">
      <div className="aspect-[9/19.5] rounded-[36px] border border-hairline-strong bg-cosmic-card p-3 shadow-card">
        <div className="relative h-full overflow-hidden rounded-[28px] bg-cosmic-black">
          {SCENES.map((s, i) => (
            <div
              key={s.id}
              data-scene={s.id}
              data-scene-active={i === scene || undefined}
              className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center transition-opacity duration-700"
              style={{ opacity: i === scene ? 1 : 0 }}
              aria-hidden={i !== scene}
            >
              <p className="text-xs uppercase tracking-[0.3em] text-text-muted">{s.label}</p>
              <p className="mt-3 font-display text-lg italic text-text-primary">{s.body}</p>
              {s.id === 'reveal' && (
                <img
                  src="/cards/the-star.webp"
                  alt=""
                  className="mt-6 h-44 rounded-md shadow-glow-gold"
                  loading="lazy"
                />
              )}
            </div>
          ))}
        </div>
      </div>
      {/* Scene rail — four pills below the phone, the active one filled gold. */}
      <ul className="mt-4 flex justify-center gap-3">
        {SCENES.map((s, i) => (
          <li key={s.id}>
            <span
              className={`block h-1 w-8 rounded-pill transition-colors ${i === scene ? 'bg-gold' : 'bg-hairline-strong'}`}
              aria-label={`${s.label}${i === scene ? ' (current)' : ''}`}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
